import React, { useState } from "react";
import Hero from "../components/Cabins/Hero";
import Brochure from "../components/Shared/Brochure";
import SingleCabin from "../components/Cabins/SingleCabin";
import { cabinData } from "../data";
import VideoPlayerModal from "../components/Shared/VideoPlayerModal";

const Cabins = () => {
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const handleOpen = () => setOpenVideoModal(true);
  const handleClose = () => setOpenVideoModal(false);
  
  return (
    <div>
      {openVideoModal && (
        <VideoPlayerModal
          url="https://www.youtube.com/watch?v=krOjUoK7ZD0"
          handleClose={handleClose}
        />
      )}
      
      <Hero />
      {cabinData.map((card, index) => (
        <SingleCabin
          image={card.image}
          name={card.name}
          size={card.size}
          price={card.price}
          ticks={card.ticks}
          features={card.features}
          key={index}
        />
      ))}
      <Brochure />
    </div>
  );
};

export default Cabins;
